import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { ContractDto } from 'src/app/models/contractDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { EmployeeDto } from 'src/app/models/EmployeeDto';
import { Profile } from 'src/app/models/profile';
import { DocumentModel } from 'src/app/models/requests/DocumentUploadDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { VendorsService } from 'src/app/services/vendors.service';

@Component({
  selector: 'app-employee-reports',
  templateUrl: './employee-reports.component.html',
  styleUrls: ['./employee-reports.component.css']
})
export class EmployeeReportsComponent implements OnInit {

  constructor(private router:Router, private employeeService: EmployeesService,private contractService: ContractsService, private notification: NotificationService,
    private vendorService: VendorsService, private requestApprovalService: RequestApprovalsService, private departmentService: DepartmentsService,
    private tokenService: TokenService,private userServis: UserService) { }

  ngOnInit(): void {
    this.loadRecords();
    this.loading = false;
  }
  biometricUpdateTitle='Biometric Info Update';
  Requests: ContractDto[] = [];
  Contracts: ContractDto[] = [];
  
  ViewRequestVisible = false;
  Departments: DepartmentDto[] = [];
    terminationComment=''
    terminationDate:Date = new Date();
    isTerminationVisible:boolean=false;
  bioOfficerName: string = '';
  datecaptured:Date = new Date();
  biometricenddate: Date = new Date();
  biometricstartdate: Date = new Date();
  Employees: EmployeeDto[] = [];
  ViewEmployeeVisible: boolean = false;
  UpdateEmployee: any;
  public searchText: string = '';
  loading: boolean = true;
  userRole: string = ''
  edit: boolean = false
  updateButtonVisible: boolean = false
  safetyOption: boolean = false;
  biometricOption: boolean = false;
  contract: any;
  safetyStatus: boolean = false;
  biometricStatus: boolean = false;
  safetyOfficer: string = ''
  safetyInductionDate:Date = new Date();
  size: number = 0;
  Documents: DocumentModel[] = [];
  isChangeOkLoading = false;
  isSafetyVisible:boolean =false;
  isBiometricModalVisible:boolean=false;
safetyTitle:string="Safety Info Update";
terminateTitle:string='Terminate Employee : ';
selectedDepartmentId: number = 0;
selectedUserEmail:string ='';
selectedStatus:string ='';
Statuses:any[]=[];
Users :Profile[]=[];


  close(): void {
    this.ViewEmployeeVisible = false;
  //  this.edit = false
    //this.getUserData();
  }
  openDocuments() {
    
    var id = this.UpdateEmployee.id;
    this.router.navigate(['/employeedocuments'], { queryParams: { id } });

  }

  async onContractChange(e: any) {
    var id = this.contract.id;
    var type = this.contract.type;
  //  console.log(e);
    let resContracts = await this.employeeService.getByRequest(id,type).toPromise();
    this.Employees = <EmployeeDto[]>resContracts.responseData;
  this.size=this.Employees.length;
  }


  getStatusColor(status: boolean): string {
    if (status) {
      return 'user-active';
    }
    else { return 'user-not-active' }

  }
  async loadRecords() {
    
    let resEmployees = await this.employeeService.getEmployees().toPromise();
    this.Employees = <EmployeeDto[]>resEmployees.responseData;
    this.size = this.Employees.length;

    let resRequests = await this.contractService.getContracts().toPromise();
    this.Requests = <ContractDto[]>resRequests.responseData;
    this.Contracts =  <ContractDto[]>resRequests.responseData;
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let Users = await this.userServis.getUsers().toPromise();
    this.Users = <Profile[]>Users.responseData;

    this.getStatusData();

  }


  async onFunctionChange(e: any){
  
 
    let resRequests = await this.employeeService.getByFunction(this.selectedDepartmentId).toPromise();
    this.Employees = <EmployeeDto[]>resRequests.responseData;
    
 
  this.size=this.Employees.length;


      }
    
      async onUserChange(e: any)
      {
    
        //let resRequests = await this.contractService.GetByCreator(this.selectedUserEmail).toPromise();
        //this.Requests = <ContractDto[]>resRequests.responseData;
    
      }
      async onStatusChange(e: any)
      {
     
         let resRequests = await this.employeeService.getByStatus(this.selectedStatus).toPromise();
         this.Employees = <EmployeeDto[]>resRequests.responseData;
         this.size = this.Employees.length;
    
      }
      getStatusData()
      {
       var statuses =  [{
      name:"Active",
      value:"True"   } , {name:"Inactive",  value:"False"  } 
      ];
    
      this.Statuses =statuses;
      
    
      }
      exportExcel() {
        if (this.Requests.length > 0) {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.Requests);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "ExportExcel");
          });
        }
      }
      saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    
}
